import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { GaPageView } from "../../services/ga.service";
import PleaseWaitGif from '../../images/please-wait-anime.gif';
import { Button } from "../../common/components/buttons";
import ErrorSsoGif from '../../images/error.gif';
import { authenticateUser, ssoLogin as ssoSamlToken } from "../node20/AuthLogin/login.action";
import { ssoLogin, userLogin } from "../../redux/action-creators/ClaimDetailsAction";

function SSO() {
    const dispatch = useDispatch()
    const history = useHistory()
    const [error, setError] = useState<boolean>(false);
    const [ entityId, setEntityId] = React.useState<number>();

    useEffect((): void => {
        const url = window.location;
        const token = new URLSearchParams(url.search).get('token') as string;
        loginWithToken(token);
        GaPageView('/sso-saml');
    }, [window.location]);

    const postLogin =  (result) => {
        dispatch(userLogin({
            isLoginSkipped: false,
            isUserLoggedIn: true,
            domainName:result?.domainName
        }));
        authenticateUser(result);
        history.push(`/home`);
    }

    const loginWithToken = async (token: string) => {
        const res = await ssoSamlToken(token);
        if (res?.accessToken) {
            postLogin(res);
        } else {
            dispatch(ssoLogin(res.message))
            setError(true);
        }
    }

    return !error ?
                    (<div className="p-6 fixed bg-white w-full overflow-hidden" style={{ inset: 0, zIndex: 999, height: '100vh' }}>
                        <div className="text-center d-flex flex-col items-center gap-6 justify-center" style={{ height: '100vh' }}>
                            <img src={PleaseWaitGif} className="w-full px-9" alt="Verifying the credentials, please wait" style={{ maxWidth: '250px' }}  />
                            <p className="fw-sb text-mdl leading-xl mb-0">Please bear with us as we locate your credentials. It won't take much longer!</p>
                        </div>
                    </div>)
                    :
                    (<div className="p-6 fixed bg-white w-full overflow-hidden" style={{ inset: 0, zIndex: 999, height: '100vh' }}>
                        <div className="text-center d-flex flex-col items-center gap-6 justify-center" style={{ height: '100vh' }}>
                            <img src={ErrorSsoGif} className="w-full px-9" alt="Verifying the credentials, please wait" style={{ maxWidth: '250px' }} />
                            <p className="fw-sb text-mdl leading-xl mb-0">We apologize, but it seems your user credentials don't match our records. Please log in as a guest user.</p>
                            <Button className="primary" style={{ minWidth: '250px' }} onClick={() => history.push('/new-home', { entityId })}>Continue as guest user</Button>
                        </div>
                    </div>) 
}

export default SSO;